import { Link } from "react-router-dom"

export default function ProjectCard({ project }) {
  const categoryMap = {
    model: "Модель в БАЗИС",
    client: "Чертежи",
    pasport: "Паспорт",
  };

  return (
    <Link
      to={`/portfolio/${project.slug}`}
      className="group relative border border-slate-200 rounded-3xl overflow-hidden bg-white transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_18px_32px_rgba(15,23,42,0.14)]"
    >
      <div className="absolute inset-x-0 top-0 h-24 bg-gradient-to-b from-cyan-100/70 to-transparent pointer-events-none" />

      <div className="relative w-full overflow-hidden rounded-t-3xl bg-slate-100">
        <div className="pb-[58%]" />
        <img
          src={project.preview}
          alt={project.title}
          className="absolute inset-0 m-auto max-w-full max-h-full object-contain transition-transform duration-300 group-hover:scale-[1.03]"
        />
      </div>

      <div className="p-5">
        <h3 className="font-semibold text-slate-900 text-lg leading-tight">{project.title}</h3>
        {project.category && (
          <p className="mt-2 inline-flex items-center rounded-full bg-slate-100 px-2.5 py-1 text-xs font-medium text-slate-600">
            {categoryMap[project.category] || project.category}
          </p>
        )}
        <p className="mt-3 text-sm text-slate-500">Открыть проект →</p>
      </div>
    </Link>
  )
}
